import { FocusEventHandler, useCallback, useState } from 'react';

interface IUseInputHandlesProps<ElementType> {
  onBlur?: FocusEventHandler<ElementType>;
  onFocus?: FocusEventHandler<ElementType>;
}

export function useFocusDetector<ElementType = Element>({
  onBlur,
  onFocus,
}: IUseInputHandlesProps<ElementType>) {
  const [isFocused, setIsFocused] = useState(false);

  const handleBlur = useCallback<FocusEventHandler<ElementType>>(
    (event) => {
      setIsFocused(false);

      onBlur?.(event);
    },
    [onBlur],
  );

  const handleFocus = useCallback<FocusEventHandler<ElementType>>(
    (event) => {
      setIsFocused(true);

      onFocus?.(event);
    },
    [onFocus],
  );

  return {
    handleBlur,
    handleFocus,
    isFocused,
  };
}
